import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=72773d4a&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BFormCheckbox, BRow, BAlert, BForm, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BFormCheckbox, BRow, BAlert, BForm, BCard, BContainer})
    

export default component.exports